import React from 'react';
import { useDispatch } from 'react-redux';
import { actions as modalActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import TextInfo, {
  TEXT_INFO_COLOR,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_KIND,
  TEXT_INFO_SIZE,
  TEXT_INFO_ALIGN,
  TEXT_INFO_DISPLAY,
} from '@gcloud-npm/next12.components.text-info-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import Icon from '@gcloud-npm/next12.components.icon-n';

const COMPONENT_NAME = 'Ver ';

const EnviarDocumentos = (props) => {
  const dispatch = useDispatch();
  let { taggingInfo } = props;

  if (!taggingInfo) {
    taggingInfo = {
      componentName: COMPONENT_NAME,
      componentProduct: '',
      componentVariation: 'all',
    };
  }

  const closeModal = () => {
    dispatch(modalActions.addModal({ type: 'MODAL', id: '' }));
  };

  const printX = () => {
    return (
      <>
        <span className="closeButton">
          <CustomLink
            taggingInfo={{
              ...taggingInfo,
              componentContent: 'cerrar',
            }}
            onClick={closeModal}
          >
            <Icon id="Cerrar" color="white" kind="M" size={16} segment="emp" />
          </CustomLink>
        </span>
        <style jsx>
          {`
            .closeButton {
              position: absolute;
              top: calc(50% - 0.688rem);
              left: 1.5rem;
            }
          `}
        </style>
      </>
    );
  };

  const printHeader = () => {
    return (
      <>
        <div className="header__wrapper">
          {printX()}
          <TextInfo
            text="Envía tu documentación"
            align={TEXT_INFO_ALIGN.LEFT}
            size={TEXT_INFO_SIZE.TITLE4}
            color={TEXT_INFO_COLOR.WHITE}
            fontType={TEXT_INFO_FONT_WEIGHT.REGULAR}
            kind={TEXT_INFO_KIND.SPAN}
            display={TEXT_INFO_DISPLAY.INLINE}
            className="header_text"
          />
        </div>
        <style jsx>
          {`
            .header__wrapper {
              position: relative;
              text-align: center;
              height: 4rem;
              padding: 0.938rem 1.5rem;
              background-color: var(--color-emp--blue);
            }
          `}
        </style>
      </>
    );
  };

  const printEnviarDocumentos = () => {
    return (
      <>
        <div className="wrapper__EnviarDocumentos">
          <div className="titulo">
            <TextInfo
              text="<b>¿Cómo enviar la documentación?</b>"
              align="left"
              fontType="font-regular"
              size="title04"
              color="grey5"
            />
          </div>
          <div className="subtitulo">
            <TextInfo
              text="Una vez rellenes la inscripción (paso 1) te llegará un correo de confirmación en el que aparece el botón <b>DOCUMENTACIÓN</b>.<br><br> Tendrás que pulsar en ese botón y proceder a adjuntar los documentos que a continuación te detallamos:"
              align="left"
              fontType="font-regular"
              size="title06"
              color="grey5"
            />
          </div>
          <ul className="listado">
            <li className="listado--item">
              <TextInfo
                text="<b>DNI</b>"
                align="left"
                fontType="font-regular"
                size="title06"
                color="grey5"
              />
            </li>
            <li className="listado--item">
              <TextInfo
                text="Certificado de <b>Vida Laboral</b>"
                align="left"
                fontType="font-regular"
                size="title06"
                color="grey5"
              />
            </li>
            <li className="listado--item">
              <TextInfo
                text="Certificado de empresa indicando puesto de trabajo</b>"
                align="left"
                fontType="font-regular"
                size="title06"
                color="grey5"
              />
            </li>
            <li className="listado--item">
              <TextInfo
                text="<b>Justificante del tamaño de la pyme</b> de entre 10 y 249 trabajadores"
                align="left"
                fontType="font-regular"
                size="title06"
                color="grey5"
              />
            </li>
            <li className="listado--item">
              <TextInfo
                text="Resultado del <b>Test de Diagnóstico Digital</b> de la pyme de la web acelerapyme.es"
                align="left"
                fontType="font-regular"
                size="title06"
                color="grey5"
              />
            </li>
            <li className="listado--item">
              <TextInfo
                text="<b>Bono de formación</b> obtenido tras el proceso de preinscripción en la EOI. Debes elegir el programa Generación digital Pymes - Personas equipos Directivos"
                align="left"
                fontType="font-regular"
                size="title06"
                color="grey5"
              />
            </li>
          </ul>
        </div>
        <style jsx>
          {`
            .wrapper__EnviarDocumentos {
              padding: 2.5rem;
              height: calc(100vh - 4rem);
              .titulo {
                margin-bottom: 1.5rem;
              }
              ul {
                margin-left: 1.25rem;
              }
              .listado--item {
                padding: 0.9375rem 0;
                list-style: initial;
                color: var(--color-emp--grey5);
                .margin-top {
                  margin-top: 0.5rem;
                }
              }
            }
          `}
        </style>
      </>
    );
  };

  return (
    <>
      <div className="EnviarDocumentosModal">
        {printHeader()}
        {printEnviarDocumentos()}
      </div>
      <style jsx>
        {`
          .EnviarDocumentosModal {
            height: 100vh;
            width: 100vw;
            background: white;
            overflow: auto;
          }
          @media screen and (min-width: 769px) {
            .EnviarDocumentosModal {
              width: 50vw;
              min-width: 43.75rem;
            }
          }
        `}
      </style>
    </>
  );
};

export default EnviarDocumentos;
